import { useIntl } from 'react-intl';

import type { Locale } from '@/types/regionTypes';
import { LanguageSlugEnum } from '@/types/regionTypes';

import { Summary } from '@/components/Summary';
import { commonMessages } from '@/messages/common';
import type { CheckoutState } from '@/states/checkout';

interface GiftSummaryProps {
  checkout: CheckoutState<true>['checkout'];
  locale: Locale;
  onEdit: () => void;
}

export const GiftSummary = ({
  checkout: { giftFrom, giftMessage, isGift },
  locale,
  onEdit,
}: GiftSummaryProps) => {
  const { formatMessage } = useIntl();

  const fromMessage = (locale: Locale, giftFrom: string) => {
    if (locale.slug === LanguageSlugEnum.ja) {
      return `${giftFrom} ${formatMessage(commonMessages.from)}`;
    }
    return `${formatMessage(commonMessages.from)} ${giftFrom} `;
  };

  return isGift ? (
    <Summary data-test-id='GiftSummary' name='gift'>
      <Summary.Header data-test-id='GiftSummaryHeader' onClick={onEdit}>
        {formatMessage(commonMessages.gifting)}
      </Summary.Header>
      <Summary.Section data-test-id='GiftSummarySection'>
        <Summary.Entry data-test-id='GiftSummaryEntry'>
          <Summary.Line data-test-id='GiftSummaryLine-Bold' isBold>
            {fromMessage(locale, giftFrom || '')}
          </Summary.Line>
          <Summary.Line data-test-id='GiftSummaryLine'>
            {giftMessage}
          </Summary.Line>
        </Summary.Entry>
      </Summary.Section>
    </Summary>
  ) : null;
};
